import { footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 font-heading text-xl font-semibold">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-book-2-line"></i>
              </span>
              漂亮的小姨子
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-100 max-w-md">
              围绕《漂亮的小姨子》整理小说、漫画、同人与番外等衍生内容，并梳理第二季与续集的信息方向，帮助读者按同一方向找到想看的部分。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["小说", "漫画", "同人", "番外", "第二季", "续集"].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 text-xs rounded-full bg-secondary-800 text-secondary-50 whitespace-nowrap"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base font-semibold text-secondary-50">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-sm text-secondary-100 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-200">
            本站仅作衍生内容的信息整理与分类导航，不提供、不存储具体作品内容。
          </p>
          <a
            href="#top"
            className="text-xs text-secondary-100 hover:text-accent-300 transition-colors whitespace-nowrap"
          >
            回到顶部 <i className="ri-arrow-up-line"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}